export default __webpack_public_path__ + "static/SRUS S190 - Product Specifications & Technical Data-77bc0b0ab3162aea0aa0593c60ae24b6.pdf";